"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.chat-thread-sharing.disabled': '聊天线程分享功能在您当前的计划中不可用。',
};
